import React from "react";
import { Button } from "../../components/ui/button";
import { Download, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CTASection() {
  const createPageUrl = (pageName: string) => {
    // Map page names to their correct URL paths
    const pagePaths: { [key: string]: string } = {
      'Downloads': '/downloads',
      'ForMyClients': '/for-my-clients',
      'Home': '/home'
    };
    
    return pagePaths[pageName] || `/${pageName.toLowerCase()}`;
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-teal-900 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-headline text-white mb-6">
            Ready to Understand Your <span className="text-blue-300">True Self</span>?
          </h2>
          
          <p className="hero-subheadline text-slate-300 max-w-3xl mx-auto mb-12">
            Join thousands of couples who have transformed their relationships with objective, AI-powered insights from their real conversations.
          </p>
        </div>
        
        {/* Get the App CTA */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="text-center mb-6">
              <h3 className="feature-title text-white mb-2">Get the App</h3>
              <p className="text-slate-300">Download WeSonder on your preferred platform and start your journey of self-discovery</p>
            </div>
            
            <div className="text-center">
              <Link to={createPageUrl("Downloads")}>
                <Button 
                  size="lg"
                  className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 text-lg font-semibold group transition-all duration-200"
                >
                  <Download className="w-5 h-5 mr-2" />
                  Download Now
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
        
        {/* Trust Indicators */}
        <div className="mt-16 text-center">
          <div className="flex justify-center">
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                <Download className="w-4 h-4 text-white" />
              </div>
              <span className="text-slate-300">Available on iOS, Android & Mac</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 